import { Autocomplete, TextField, Chip } from '@mui/material';

export const MultiAutocomplete = ({
    options = [],
    label = '',
    value = [],
    onChange,
    name,
    disabled,
    placeholder,
    size = 'small',
    fullWidth = true
}) => {
    // value es array de ids → lo mapeamos a array de objetos {id, displayName}
    const selectedOptions = options.filter(opt => value.includes(opt.id));

    const handleChange = (_, newValue) => {
        const ids = newValue.map(opt => opt.id);
        onChange?.(name, ids);
    };

    return (
        <Autocomplete
            multiple
            limitTags={1}
            sx={{ backgroundColor: 'white' }}
            disableCloseOnSelect
            size={size}
            fullWidth={fullWidth}
            disabled={disabled}
            options={options}
            value={selectedOptions}
            onChange={handleChange}
            getOptionLabel={(option) => option.displayName ?? ''}
            isOptionEqualToValue={(option, val) => option.id === val.id}
            renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => {
                    const { key, ...tagProps } = getTagProps({ index });
                    return (
                        <Chip
                            key={key}
                            label={option.displayName}
                            size="small"
                            {...tagProps}
                        />
                    );
                })
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder={placeholder}
                />
            )}
        />
    );
};